import type React from 'react';

import { Button } from '@change/ds-core-ui/Button';

import { Translate } from '@change-corgi/core-react/i18n';

import { useNextStepButtonAction } from '#src/app/pages/petitionDetails/shared/hooks';

import { ActionButtonWrapper } from './ActionButtonWrapper';

type Props = {
	sticky: boolean;
	visible: boolean;
};

export const MobileComboButton: React.FC<Props> = ({ sticky, visible }) => {
	const {
		data: { comboLink },
		action: { handleNextStepClick },
	} = useNextStepButtonAction();
	return (
		// eslint-disable-next-line @change-corgi/require-data-qa-attribute
		<ActionButtonWrapper visible={visible} sticky={sticky}>
			<Button
				variant="primary"
				className="w-full"
				as="a"
				href={comboLink}
				data-testid="signed-petition-combo-cta"
				data-qa="signed-petition-combo-cta"
				onClick={handleNextStepClick}
			>
				<Translate value="fe.pages.petition_update.combo_action_button_label" />
			</Button>
		</ActionButtonWrapper>
	);
};
